<template lang="pug">
.form-subscribe
  .form-subscribe__item
    .input-text
      input.input-text__input(
        type="email"
        placeholder="E-mail *"
        v-model.trim="fieldEmail"
        :class="{'input-text__input-error': v$.fieldEmail.$invalid && (fieldEmail.length > 0), 'input-text__input-complete': !v$.fieldEmail.$invalid && (fieldEmail.length > 0)}"
      )
  .form-subscribe__item
    .button(
      :class="{'button-disable': v$.$invalid}"
      @click="getSend()"
    )
      .button__text Subscribe
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { mapActions } from 'vuex'

export default {
  name: 'AppFormSubscribe',

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      files: '',
      fieldEmail: ''
    }
  },

  methods: {
    ...mapActions([
      'Send'
    ]),

    getSend () {
      if (!this.v$.$invalid) {
        document.querySelector('#button-form-success').click()
        this.Send({
          setting: {
            form: {
              formId: '1',
              checkField: {
                name: 'emailCheck',
                value: this.fieldEmail
              },
              isCheck: '1',
              pageId: window.appJobs.Form.pageId,
              altPage: window.appJobs.Form.altPage
            },
            mailDo: 'info@newjobs4you.com',
            emails: window.appJobs.Form.emails,
            title: 'Thank you for subscribing!',
            subject: 'You will receive our emails with hot information. "Subscribe"'
          },

          fields: [
            {
              name: 'email',
              title: 'E-mail',
              value: this.fieldEmail
            }
          ],
          files: this.files
        })

        this.fieldEmail = ''
      }
    }
  },

  validations () {
    return {
      fieldEmail: {
        required,
        email
      }
    }
  }
}
</script>
